import React, { useState } from 'react';

export default function RankPuzzle({ data, onSolved }) {
  const [items, setItems] = useState(() =>
    [...data.items].sort(() => Math.random() - 0.5)
  );
  const [dragIndex, setDragIndex] = useState(null);
  const [wrong, setWrong] = useState(false);

  const handleDragStart = (i) => setDragIndex(i);

  const handleDragOver = (e, i) => {
    e.preventDefault();
    if (dragIndex === null || dragIndex === i) return;
    const newItems = [...items];
    const [dragged] = newItems.splice(dragIndex, 1);
    newItems.splice(i, 0, dragged);
    setItems(newItems);
    setDragIndex(i);
  };

  const handleDragEnd = () => setDragIndex(null);

  // Mobile: tap to select, tap again to place
  const [selectedIndex, setSelectedIndex] = useState(null);
  const handleTap = (i) => {
    if (selectedIndex === null) {
      setSelectedIndex(i);
    } else {
      const newItems = [...items];
      const [selected] = newItems.splice(selectedIndex, 1);
      newItems.splice(i, 0, selected);
      setItems(newItems);
      setSelectedIndex(null);
    }
  };

  const handleSubmit = () => {
    const isCorrect = items.every((item, i) => item === data.correctOrder[i]);
    if (isCorrect) {
      onSolved();
    } else {
      setWrong(true);
      setTimeout(() => setWrong(false), 1200);
    }
  };

  return (
    <div className="puzzle-rank">
      <p className="puzzle-prompt">{data.prompt}</p>
      <p className="puzzle-hint">Drag to reorder (or tap two items to swap)</p>
      <div className={`rank-list ${wrong ? 'rank-wrong' : ''}`}>
        {items.map((item, i) => (
          <div
            key={item}
            className={`rank-item ${dragIndex === i ? 'rank-dragging' : ''} ${selectedIndex === i ? 'rank-selected' : ''}`}
            draggable
            onDragStart={() => handleDragStart(i)}
            onDragOver={(e) => handleDragOver(e, i)}
            onDragEnd={handleDragEnd}
            onClick={() => handleTap(i)}
          >
            <span className="rank-number">{i + 1}.</span>
            <span className="rank-name">{item}</span>
            <span className="rank-handle">⠿</span>
          </div>
        ))}
      </div>
      {wrong && <p className="puzzle-wrong">Not quite! Try again 🤔</p>}
      <button className="puzzle-submit" onClick={handleSubmit}>Lock it in!</button>
    </div>
  );
}
